import { render, staticRenderFns } from "./DepartmentDeployments.vue?vue&type=template&id=59a52375&"
import script from "./DepartmentDeployments.vue?vue&type=script&lang=js&"
export * from "./DepartmentDeployments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports